/**
 * 排出事業者
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/emissions`

const emission_user = {
  namespaced: true,
  state: {},
  actions: {
    /**
     *
     * @param commit
     * @param emission_id
     * @return {Promise<unknown>}
     */
    index ({ commit }, { emission_id, page }) {
      const api_path = `${API_PATH}/${emission_id}/users`
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: {page: page} }).then(data => {
          resolve(data.content)
        })
      })
    },
    new ({ commit }, { emission_id }) {
      const api_path = `${API_PATH}/${emission_id}/users/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    edit ({ commit }, { emission_id, id }) {
      const api_path = `${API_PATH}/${emission_id}/users/${id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { emission_id, params }) {
      const api_path = `${API_PATH}/${emission_id}/users`
      return new Promise( ( resolve ) => {
        Vue.$http.post(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    update ({ commit },{ emission_id, id, params }) {
      const api_path = `${API_PATH}/${emission_id}/users/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.patch(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    destroy ({ commit }, { emission_id, id }) {
      const api_path = `${API_PATH}/${emission_id}/users/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}

export default emission_user

